const time = {
    "周": "Minggu",
    "天": "Hari",
    "小时": "Jam",
    "分钟": "Minit",
    "刚刚": "Baru sahaja",
    "前": "Lalu",
    "昨天": "Semalam",
    "星期一": "Isnin",
    "星期二": "Selasa",
    "星期三": "Rabu",
    "星期四": "Khamis",
    "星期五": "Jumaat",
    "星期六": "Sabtu",
    "星期日": "Ahad"
}

export default time;